import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    ISieveConf,
    ISieveFilterObject,
    SieveOperator,
    SieveString
} from '../../helpers/sieve/sieveString.class';

@Component({
    selector: 'app-searchbar',
    templateUrl: 'searchbar.component.html',
    styleUrls: ['searchbar.component.css']
})
export class SearchbarComponent {
    /** OUTPUTS */
    @Output() changePageEvent = new EventEmitter<ISieveConf>();
    @Output() searchEvent = new EventEmitter<ISieveConf>();
    @Output() linkClickEvent = new EventEmitter();
    @Output() removeClickEvent = new EventEmitter();
    @Output() banClickedEvent = new EventEmitter();
    @Output() banReleasedEvent = new EventEmitter();
    /** INPUTS */
    @Input() page: number; //REQUIRED
    @Input() pageSize: number; //REQUIRED
    @Input() customFilterName: string; //REQUIRED
    @Input() rowsTotal: number; //REQUIRED
    @Input() isLinkVisibile = false;
    @Input() isDeleteVisibile = false;
    @Input() isUserList = false;
    @Input() customActionLink: Function;
    @Input() customActionDelete: Function;
    @Input() customActivatedShowBan: Function;
    @Input() customDeactivatedShowBan: Function;
    @Input() isBanPressed = false;
    public filters: string;

    /* PROPERTIES*/
    public _pageSizes: number[] = [5, 10, 15, 20, 25, 30, 50, 100];

    /**TODO: pageTotal viene chiamato molte volte.
     *  Servirebbe una proprità private _pageTotal impostata ogni volta che venegono cambiate rowsTotal o pageSize,
     *  e un getter che restituisca _pageTotal.
     */
    get pageTotal() {
        return Math.ceil(Number(this.rowsTotal) / Number(this.pageSize)) || 1;
    }
    private get _sieveFilters(): ISieveFilterObject[] {
        if (!this.filters) {
            return [];
        } else {
            const _ftrs = this.filters.split(' ');
            const _filters: ISieveFilterObject[] = [];
            for (const _filter of _ftrs) {
                _filters.push({
                    key: this.customFilterName,
                    operator: SieveOperator.Contains,
                    value: encodeURIComponent(_filter)
                });
            }
            return _filters;
        }
    }
    private get _sieveConf(): ISieveConf {
        const sieveConf: ISieveConf = {};
        sieveConf.page = this.page;
        sieveConf.pageSize = this.pageSize;
        sieveConf.filters = this._sieveFilters;
        return sieveConf;
    }
    /** visibility condition */
    get visible(): boolean {
        const filtersIsTrue = this.filters ? this.filters.length !== 0 : false;
        const pageTotalIsTrue = this.pageTotal !== null && this.pageTotal !== undefined;
        const rowsTotalIsFalse = this.rowsTotal !== 0;
        return filtersIsTrue || pageTotalIsTrue || !rowsTotalIsFalse;
    }

    constructor() {}

    //CHANGE PAGE or PAGE SIZE
    private _onPageChange() {
        this.changePageEvent.emit(this._sieveConf);
    }

    changePageSize() {
        this.page = 1; //Because if you're into a specific page, but items are not enough...
        this._onPageChange();
    }

    pageNext() {
        if (this.page < this.pageTotal) {
            this.page++;
            this._onPageChange();
        }
    }

    pagePrev() {
        if (this.page > 1) {
            this.page--;
            this._onPageChange();
        }
    }

    pageFirst() {
        this.page = 1;
        this._onPageChange();
    }

    pageLast() {
        this.page = this.pageTotal;
        this._onPageChange();
    }

    //SEARCH
    private _onSearch() {
        this._sieveConf.page = 1;
        // this.pageSize = SieveString.DEAFULT_PAGE_SIZE;
        this.searchEvent.emit(this._sieveConf);
    }
    confirmSearch() {
        this._onSearch();
    }

    resetSearch() {
        this.page = SieveString.DEAFULT_PAGE;
        this.filters = '';
        this._onSearch();
    }

    // REFRESH
    refreshData() {
        console.log('sieve refresh');
        this.page = SieveString.DEAFULT_PAGE;
        this.changePageEvent.emit(this._sieveConf);
    }

    actionToDoLink() {
        this.linkClickEvent.emit(this.customActionLink);
    }

    actionToDoDelete() {
        this.removeClickEvent.emit(this.customActionDelete);
    }

    actionToDoBan() {
        this.page = 1;
        if (this.isBanPressed) {
            this.banClickedEvent.emit(this.customActivatedShowBan);
        } else {
            this.banReleasedEvent.emit(this.customDeactivatedShowBan);
        }
        this._onPageChange();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/searchbar/searchbar.component.ts